module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "注册项配置 ",
      "name": "first"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "left",
      "label-width": "150px"
    }
  }, [_c('div', {
    staticClass: "section-body"
  }, _vm._l((_vm.form), function(item, key) {
    return _c('el-form-item', {
      key: key,
      attrs: {
        "label": item.name
      }
    }, [_c('el-switch', {
      attrs: {
        "active-color": "#13ce66",
        "inactive-text": "是否开启",
        "inactive-color": "#efefef"
      },
      on: {
        "change": function($event) {
          return _vm.changeOpen(key)
        }
      },
      model: {
        value: (item.is_open),
        callback: function($$v) {
          _vm.$set(item, "is_open", $$v)
        },
        expression: "item.is_open"
      }
    }), _vm._v("   \n            "), _c('el-switch', {
      attrs: {
        "active-color": "#13ce66",
        "inactive-text": "是否必填",
        "inactive-color": "#efefef"
      },
      on: {
        "change": function($event) {
          return _vm.changeRequired(key)
        }
      },
      model: {
        value: (item.is_required),
        callback: function($$v) {
          _vm.$set(item, "is_required", $$v)
        },
        expression: "item.is_required"
      }
    })], 1)
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "注册协议",
      "name": "second"
    }
  }, [_c('div', {
    staticClass: "section-white content-padded"
  }, [_c('el-form', {
    ref: "form_content",
    attrs: {
      "model": _vm.form_content,
      "rles": _vm.rules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "注册协议",
      "prop": "content"
    }
  }, [_c('vue-html5-editor', {
    attrs: {
      "content": _vm.form_content.content,
      "height": 360
    },
    on: {
      "change": _vm.updateContent
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveContent
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4c9cdce4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c9cdce4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/registersetting/index.vue
// module id = 2694
// module chunks = 0